import {useReportingConfigurationsQuery} from '@/generated/graphql';
import {Typography} from '@mui/material';

export const SavedViewsCount = () => {
  const {data} = useReportingConfigurationsQuery();
  const count = data?.reportingConfigurations.length;
  if (!count) return null;

  return (
    <Typography
      component="span"
      aria-label={`${count} saved`}
      sx={{fontSize: 11, fontWeight: 500, color: 'chart.meta'}}
    >
      {count}
    </Typography>
  );
};
